import type { Schedule } from "@medplum/fhirtypes";
import { DEVICE_ENTITY_ID_SYSTEM, LOCATION_ENTITY_ID_SYSTEM } from "@repo/api";

/**
 * How many schedules name each resource as an actor, keyed by that resource's id.
 *
 * Shared because the device and location views both report it and must not
 * disagree: `Schedule.actor` is array membership, which the equality-only query
 * builder cannot express, so both resolve it in code.
 */
export function countSchedulesByActor(schedules: Schedule[], resourceType: "Location" | "Device"): Map<string, number> {
  const counts = new Map<string, number>();
  const system = resourceType === "Location" ? LOCATION_ENTITY_ID_SYSTEM : DEVICE_ENTITY_ID_SYSTEM;

  for (const schedule of schedules) {
    for (const actor of schedule.actor ?? []) {
      const id = actor.identifier?.system === system ? actor.identifier.value : undefined;
      if (!id) continue;
      counts.set(id, (counts.get(id) ?? 0) + 1);
    }
  }
  return counts;
}
